// extracted by mini-css-extract-plugin
export default {"headerview":"headerview_a8cb15639aa4143138ef","navbar":"navbar_a0831c9474ad62362212"};